module.exports = {
  所有应用: "All applications",
  确定: "Ok",
  增加委托: " Add entrust",
  返回授权列表: "Back to list",
  邮箱: "mailbox",
  手机号: "Phone Number",
  修改: "modify",
  "保存分类成功,是否回到应用列表？":
    "Save classification successfully, do you want to return to the application list?",
  "是否确认删除？": "Are you sure you want to delete?",
  发送验证码: "Send",
  再次发送: "Send again",
  重新发送: "Resend",
  申请人: "applicant",
  任务名称: "Task name",
  审批类型: "Approval type",
  状态: "state",
  操作: "operation",
  详情: "details",
  表单填写: "Form filling",
  取消: "cancel",
  请填写分类名称: "Please fill in the classification name！",
  分类已存在: "Classification already exists",
  分类不能超过10个: "No more than 10 categories",
  权限选择: "jurisdiction",
  原因: "reason",
  提交: "Submit",
  请选择: "Please select",
  登录: "Sign in",
  请输入密码: "Please enter the user password",
  请输入账号:"Please enter the account number",
  请输入租户标识: "Please enter tenant ID",
  "请输入用户名/手机号/邮箱": "Enter one user name",
  请输入用户名: "Enter one user name",
  登录认证中心: "Log in",
  必填字段: "Mandatory Field",
  请输入手机号码: "Please enter your mobile phone number",
  请输入手机验证码: "verification code",
  请输入图形验证码: "verification code",
  应用管理: "App Manage",
  切换至: "Switch to",
  ioa快速登录: "IOA Quick Logon",
  账号密码登录: "Account Password Login",
  "企业微信2.4": "Enterprise Wechat 2.4",
  使用: "Use",
  以上版本扫描二维码登录: "Above Version Scan QR code Login",
  或: "or",
  "手机号码格式不正确！": "Incorrect format of mobile phone number！",
  "请输入图形验证码！": "Please input the graphic verification code！",
  必须是数字: "It has to be a number",
  请输入有效身份证号码: "Please enter a valid ID number.",
  "邮箱或者以中文、英文、数字、下划线以及横线组成！":
    "Email or in Chinese, English, numbers, underscores and horizontal lines!",
  两次密码输入不一致: "The two passwords are inconsistent",
  必须是: "It has to be",
  位: "digit",
  是不支持的表单类型: "Is an unsupported form validation type",
  正则验证不通过: "Regular verification failed",
  输入不能超过: "Input cannot exceed",
  个字符: "character",
  输入不能少于: "Input cannot be less than",
  请检查: "Please check",
  长期有效: "Long term validity",
  后生效: "Take effect after",
  已失效: "Invalid",
  后失效: "Post failure",
  被禁用: "Disabled",
  无认证: "No certification",
  上次认证: "Last certification",
  口令: "Password",
  二维码: "QR code",
  指纹: "fingerprint",
  动态码: "Dynamic code",
  短信: "Short Message",
  邮件: "Mail",
  异常错误: "Abnormal error",
  验证码必填: "Verification code is required",
  手机号码有误: "Wrong cell phone number",
  "忘记密码?": "Forget password?",
  返回其他方式登录: "Login in other ways",
  应用列表: "Application List",
  ID管家: "ID Keeper",
  权限申请: "Authorization",
  我的任务: "My Task",
  切换用户: "Switch Users",
  用户信息: "User information",
  修改密码: "Change Password",
  退出登录: "Login out",
  绑定ID管家: "Binding ID keeper",
  请打开ID管家: "Please open ID keeper",
  请扫描上方二维码绑定: "Scan QR code for binding",
  ID管家下载: "ID keeper Download",
  原密码: "Original password",
  请输入原密码: "Please enter the original password",
  新密码: "New password",
  请输入新密码: "Please enter a new password",
  确认修改密码: "Confirm password change",
  确认新密码: "Confirm new password",
  请再次输入新密码: "Please enter the new password again",
  重置密码: "reset password",
  确认重置密码: "Confirm reset password",
  "忘记密码-短信重置密码": "Forget password - reset password",
  "手机号码有误！": "Wrong cell phone number",
  请输入您的手机号码: "Please enter your mobile phone number",
  "请输入动态码！": "Please input dynamic code！",
  重置验证: "Reset validation",
  返回登录: "Sign in",
  返回: "return",
  设置手机号: "Set mobile number",
  验证码: "Verification code",
  "请输入验证码！": "Please enter the verification code",
  邮件重置: "Mail reset",
  请输入邮箱: "Please input email",
  返回选择重置方式: "Return to select reset mode",
  下一步: "next step",
  注册: "Register",
  最后访问时间: "Last visit time",
  用户名: "user name",
  应用分类名: "App category name",
  生效日期: "take effect",
  用户属性: "user attribute",
  返回应用列表: "Back to list",
  新增申请: "New application",
  权限定义: "Authority definition",
  错误信息: "error message",
  添加应用分类: "Add application category",
  添加应用: "Add app",
  应用排序: "Application sequencing",
  添加: "Add To",
  删除: "Delete",
  "<返回": "<return",
  保存分类: "save",
  请输入应用分类名: " Classification name",
  "权限：": "jurisdiction：",
  "授权状态：": "status：",
  可用: "available",
  禁用: "Disable",
  "账号状态：": "Account status：",
  账号期限: "Account period",
  新增委托: "Add delegation",
  委托列表: "Delegation list",
  "当前账号总数：": "Number of accounts：",
  拥有:"own",
  他人委托:"other entrust",
  可使用:"available",
  IAM租户管理平台:"IAM Tenant",
  数据访问控制平台:"Access control",
  开发配置平台:"Development",
  身份管理平台:"Identity management",
  修改成功:"changed",
  从:"from",
  到:"to",
  开始:"start",
  结束:"end",
  未设置生效日期:"No effective date set",
  生成二维码:"Generate QR code",
  流程审批:"Process approval",
  "您的企业微信账号还未与本系统用户绑定，请输入本系统的用户名密码进行绑定":"Your enterprise wechat account has not been bound with the user of the system. Please enter the user name and password of the system for binding",
  企业微信绑定账号:"Enterprise wechat binding account",
  请选择您要登录的用户:"Please select the user you want to log in to",
  请选择您要切换的身份:"Please select the identity you want to switch",
  待处理:"Pending",
  已完成:"Completed",
  已拒绝:"Rejected",
  已取消:"Cancelled",
  不需要再处理:"No further processing is required",
  已批准:"Approved",
  请输入查询条件搜索:"Please enter query criteria to search",
  多LDAP认证:"LDAP Login",
  短信登录:"SMS Login",
  企微扫码登录:"WeCom Login",
  AD域用户登录:"AD Login",
  操作日志:"Log",
  登录e站通:"Login IAM",
  "确定要删除吗?":"Are you sure you want to delete?",
  是:"Yes",
  否:"No",
  有效期限:"Term of validity",
  "(*不选时间表示长期有效)":"(* Long term validity is not selected)",
  输入搜索关键字:"Enter search keywords",
  至:"to",
  请输入:"Please enter",
  姓名:"full name",
  密码:"password",
  "请输入IAM用户名/手机号":"Please enter IAM UserName or Phone number",
  "请输入AD域用户名":"Please enter AD UserName",
  E站通用户登录:"Username login password",
};



//////////////////
// WEBPACK FOOTER
// ./src/_i18n/language/old.js
// module id = 166
// module chunks = 0